import React from "react";

const CarouselDash = () => {
  return (
    <>
      <div id="demo" className="carousel slide" data-ride="carousel">
        <ul className="carousel-indicators">
          <li data-target="#demo" data-slide-to="0" className="active dot"></li>
          <li data-target="#demo" data-slide-to="1"></li>
          <li data-target="#demo" data-slide-to="2"></li>
        </ul>
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img
              src="/images/Dashimages/rectangle.png"
              alt="Los Angeles"
              className="w-100"
            />
          </div>

          <div className="carousel-item">
            <img
              src="/images/Dashimages/rectangle.png"
              alt="Chicago"
              className="w-100"
            />
          </div>

          <div className="carousel-item">
            <img
              src="/images/Dashimages/rectangle.png"
              alt="New York"
              className="w-100"
            />
          </div>
        </div>

        <a className="carousel-control-prev" href="#demo" data-slide="prev">
          <span className="carousel-control-prev-icon"></span>
        </a>
        <a className="carousel-control-next" href="#demo" data-slide="next">
          <span className="carousel-control-next-icon"></span>
        </a>
      </div>
    </>
  );
};

export default CarouselDash;
